<template>
  <div>
    <SideBar :bar_name="tabName" :user="user"></SideBar>
    <v-main>
      <v-container>
        <AgentLine v-bind="{ user, tabName }" />
      </v-container>
    </v-main>
  </div>
</template>

<script>
import SideBar from "@/components/SideBar";
import AgentLine from "@/components/ChangFamily/Agents/AgentLine";

export default {
  name: "AgentLineManagement",
  components: {
    SideBar,
    AgentLine,
  },
  data() {
    return {
      user: this.$user,
      tabName: "Agent Line User Management",
    };
  },
};
</script>
